import React from "react";
import { Navigation } from "lucide-react";
import { useI18n } from "@/i18n";

export const MapEmbed = ({ location }) => {
  const { t } = useI18n();
  if (!location) return null;
  const { lat, lng, name } = location;
  const d = 0.02;
  const bbox = `${lng - d}%2C${lat - d}%2C${lng + d}%2C${lat + d}`;
  const src = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat}%2C${lng}`;
  const directions = `https://www.openstreetmap.org/directions?to=${lat}%2C${lng}`;
  return (
    <div className="rounded-2xl overflow-hidden border border-black/5 soft-shadow bg-white">
      <iframe
        title="map"
        data-testid="map-embed"
        src={src}
        className="w-full h-64 border-0"
        loading="lazy"
      />
      <div className="flex items-center justify-between p-3">
        <div className="text-sm">
          <p className="font-semibold">{name}</p>
          <p className="text-muted-foreground text-xs">{location.address}</p>
        </div>
        <a
          data-testid="get-directions"
          href={directions}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1.5 rounded-full bg-primary text-primary-foreground px-4 py-2 text-sm font-medium hover:opacity-90 transition-opacity"
        >
          <Navigation className="h-4 w-4" /> {t("get_directions")}
        </a>
      </div>
    </div>
  );
};
